<template>
    <div>

        <div class="form-row" v-for="(esp, ie) in lista" :key="ie">
            <div class="col col-12 col-md-4">
                <az-input 
                    :label="( ie || fila || setup ) ? '' : 'Especialidade'"
                    :validate="validate" 
                    v-model="esp.id_especialidade" 
                    required 
                    type="select" 
                    optionsMode="aql" 
                    optionsData="id_especialidade"
                    :optionsSync="false"
                    service="especialidades.index"
                    optionsName="especialidades.index.ativas"
                    :optionsParm="{ ativas: true }"
                    icon="fas fa-trash-alt"
                    :buttonIcon="true"
                    buttonText="fas fa-minus"
                    buttonColor="outline-danger"
                    @clickButton="excluirEspecialidade(esp, ie)"/>
            </div>
            <div class="col col-12 col-md-8" v-if="fila">
                <div class="input-group mb-1">
                    <div class="input-group-prepend">
                        <div class="input-group-text">
                            <input type="checkbox" aria-label="Radio button for following text input" value="1"
                                v-model="esp.fl_nao_encerrar_atendimento">
                        </div>
                    </div>
                    <input type="text" class="form-control" placeholder="Não encerrar o atendimento atual ao chamar o próximo" disabled>
                </div>
            </div>
            <template v-else-if="!setup">
                <div class="col col-12 col-md-1">
                    <az-input
                        :label="ie ? '' : 'Idade Mínima'"
                        placeholder="Idade..."
                        type="number"
                        v-model="esp.in_paciente_idade_minima" />
                </div>
                <div class="col col-12 col-md-1">
                    <az-input
                        :label="ie ? '' : 'Idade Máxima'"
                        placeholder="Idade..."
                        type="number"
                        v-model="esp.in_paciente_idade_maxima" />
                </div>
                <div class="col col-12 col-md-1">
                    <az-input
                        :label="ie ? '' : 'Sexo'"
                        placeholder="Sexo..."
                        type="select"
                        :optionsList="[
                            { id: 'M', search: 'Masc' },
                            { id: 'F', search: 'Fem' }
                        ]"
                        optionsData="id"
                        v-model="esp.ch_paciente_sexo" />
                </div>

                <div class="col col-12 col-md-5">
                    <small class="form-text text-muted text-nowrap text-truncate" v-if="!ie">
                        Subespecialidade
                    </small>
                    <multiselect
                        v-model="esp.js_classes"
                        :options="options_classes"
                        :multiple="true"
                        :taggable="true"
                        @tag="addTag(esp, $event)"
                        placeholder="Selecione uma classificação de subespecialidade..."
                        selectLabel="Pressione [ENTER] para selecionar"
                        deselectLabel="Pressione [ENTER] para remover"
                        tagPlaceholder="Pressione [ENTER] para incluir"
                        selectedLabel="Selecionado">
                        <template slot="noOptions">
                            Nenhuma classificação criada.
                        </template>
                    </multiselect>
                </div>
            </template>


            <div class="col col-12 col-md-6" v-if="( 'procedimento' in esp ) && !esp.procedimento">
                <label class="form form-control alert-warning text-nowrap">
                    <i class="fa fa-exclamation-triangle mr-2" aria-hidden="true"></i>
                    <a href="#" class="alert-link" @click.prevent="abrirProcEspecialidade(esp)">
                        <small>Nenhum procedimento habilitado dessa especialidade.</small>
                    </a>
                </label>
            </div>
        </div> 

        <button type="button" class="btn btn-outline-secondary btn-sm mt-2" @click="incluirEspecialidade()">
            <i class="fas fa-plus mr-2"></i>
            Incluir Especialidade
        </button>

    </div>
</template>

<script>
import AzInput from '../../shared/forms/AzInput.vue';
import Multiselect from 'vue-multiselect';

export default {
    data () { 
        return { 
            options_classes: [], 
        }
    },

    components: { 
        AzInput,
        Multiselect, 
    },

    props: ['value', 'validate', 'fila', 'setup'],

    computed: { 
        lista: function () { 
            return this.value.filter (it => { 
                return !it.excluido;
            });
        }
    },

    methods: { 
        addTag (esp, newTag) {
            this.options_classes.push(newTag);

            if ( !esp.js_classes )
                esp.js_classes = [];

            esp.js_classes.push(newTag);
        },

        abrirProcEspecialidade (esp) { 
            this.$store.commit('setContexto', 
                { 
                    especialidade: esp.id_especialidade,
                });

            this.$router.push({ 
                name: 'c-procedimentos', 
            });
        },

        excluirEspecialidade (item, idx) { 
            if ( item.id_medico_especialidade ) { 
                item.excluido = true;
            } else { 
                this.value.splice(idx, 1);
            }
        },

        incluirEspecialidade () { 
            this.value.push({
                excluido: false, 
                id_especialidade: null, 
                js_classes: [], 
            });
        },
    },

    mounted() { 

        if ( !this.fila ) { 

            this.$util.loadItem(this, { 
                service: 'medico_especialidades',
                func: 'tags',
            })
            .then(res => { 
                this.options_classes = res;
            });
            
        }

    }

}
</script>